import type { FunctionComponent } from "react";
import { TimeAgo } from "@kanda-libs/ks-design-library";
import { CLASS_NAMES } from "./constants";
import useUpdatedAtCellProps from "./useUpdatedAtCellProps";

export interface UpdatedAtCellProps {
  date?: string | Date;
}

const UpdatedAtCell: FunctionComponent<UpdatedAtCellProps> = function ({
  date,
}) {
  const { timestamp } = useUpdatedAtCellProps(date);

  return (
    <div className="flex flex-col">
      <p className={CLASS_NAMES.label}>
        <span>Last updated: </span> <TimeAgo timestamp={timestamp} />
      </p>
    </div>
  );
};

export default UpdatedAtCell;
